module.exports = __webpack_public_path__ + "img/momo_index_button_1.766d471f.png";